import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const ViewProjectInvoiceWrapper = styled.div`
  .fields-wrapper {
    padding: 16px;
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }
  .MuiGrid2-container:first-of-type {
    margin-top: 16px;
  }
  .fee-and-expense-label {
    padding: 16px;
  }
  .cell {
    display: flex;
    justify-content: center;
  }
  .reversal-reason {
    padding: 16px;
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }
`;
